"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tools.sendContactForm.name': 'Contact Form',
    'tools.sendContactForm.description': 'Collect contact form data (name, email, phone, message) from user messages and send a contact request',
};
